module.exports = __webpack_public_path__ + "static/media/DEENCONNECT_Integration_Icon.aceb91c9.png";